var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.deviceInfo.mobile ? 'mobile-index' : '',attrs:{"id":"index"}},[_c('Header'),_c('div',{staticClass:"content"},[_c('Banner'),_c('Teacher'),_c('About')],1),_c('Fotter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }